'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// const { JSDOM } = jsdom;
// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _draftJs = require('draft-js');

require('draft-js/dist/Draft.css');

var _draftjsConductor = require('draftjs-conductor');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

var _saveUserData = require('redux/modules/saveUserData');

var _semanticUiReact = require('semantic-ui-react');

require('./MultiLine.css');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasCommandModifier = _draftJs.KeyBindingUtil.hasCommandModifier;


var IMAGE_PLACEHOLDER = "https://live.staticflickr.com/8287/29517736620_3184b66ec8.jpg";

var MultiLine = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    content_template_data: state.templateData.content_template_data,
    design_template_name: state.templateData.design_template_name,
    content_template_name: state.templateData.content_template_name,
    personal_info: state.templateData.personal_info,
    info_block: state.templateData.info_block,
    design_order: state.templateData.design_order,
    inter_section_margin: state.templateData.inter_section_margin,
    primary_color: state.templateData.primary_color,
    secondary_color: state.templateData.secondary_color,
    header_font: state.templateData.header_font,
    body_font: state.templateData.body_font,
    design_template_id: state.templateData.design_template_id,
    content_template_id: state.templateData.content_template_id,
    resume_name: state.templateData.resume_name,
    ReactGA: state.company.ReactGA,
    content_template_free: state.templateData.content_template_free,
    subscribed: state.auth.subscribed,
    all_templates_free: state.company.all_templates_free,
    show_image_upload: state.company.show_image_upload,
    text_analysis_data: state.templateData.text_analysis_data,
    highlighted_action_verb: state.templateData.highlighted_action_verb,
    analysis_mode_on: state.templateData.analysis_mode_on,
    show_comment_button: state.company.show_comment_button,
    resume_review_id: state.templateData.resume_review_id
  };
}, {
  updateInfo: templateData.updateField,
  saveUserData: _saveUserData.save
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(MultiLine, _Component);

  function MultiLine(props) {
    (0, _classCallCheck3.default)(this, MultiLine);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MultiLine.__proto__ || (0, _getPrototypeOf2.default)(MultiLine)).call(this, props));

    _this.saveState = function () {

      var object = {};
      object['personal'] = _this.props.personal_info;
      object['info'] = _this.props.info_block;
      object['design_template_id'] = _this.props.design_template_id;
      object['content_template_id'] = _this.props.content_template_id;
      object['design_order'] = _this.props.design_order.toString();
      object['inter_section_margin'] = _this.props.inter_section_margin;
      object['primary_color'] = _this.props.primary_color;
      object['secondary_color'] = _this.props.secondary_color;
      object['header_font'] = _this.props.header_font;
      object['body_font'] = _this.props.body_font;
      object['resume_name'] = _this.props.resume_name;
      object['resume_review_id'] = _this.props.resume_review_id;

      // Converting back to string so that consistency is maintained on data coming from server
      _this.props.saveUserData(object);
    };

    _this.selectAlternateWord = function (editorState) {

      var element_id = _this.props.data_id;
      var element_parent = _this.props.data_parent;
      var element_type = _this.props.data_type;

      var html = (0, _stringify2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
      _this.props.updateInfo(html, element_id, element_type, element_parent);
      _this.setState({ editorState: editorState });
    };

    _this.updateEditorInfo = function (editorState) {

      _this.setState({
        editorState: editorState
      }, function () {
        setTimeout(function () {
          return _this.focus();
        }, 0);
      });

      var element_id = _this.props.data_id;
      var element_parent = _this.props.data_parent;
      var element_type = _this.props.data_type;

      var html = (0, _stringify2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
      _this.props.updateInfo(html, element_id, element_type, element_parent);
    };

    _this._onAddImage = function (e) {
      e.preventDefault();
      var editorState = _this.state.editorState;
      var urlValue = window.prompt("Paste Image Link");
      if (parseInt(urlValue)) {
        var contentState = editorState.getCurrentContent();

        var srcList = Array(parseInt(urlValue)).fill(IMAGE_PLACEHOLDER);
        var contentStateWithEntity = contentState.createEntity("image", "IMMUTABLE", {
          srcList: srcList
        });
        var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        var newEditorState = _draftJs.EditorState.set(editorState, { currentContent: contentStateWithEntity }, "create-entity");
        _this.setState({
          editorState: _draftJs.AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ")
        }, function () {
          setTimeout(function () {
            return _this.focus();
          }, 0);
        });
      } else {
        window.alert('please enter a valid integer');
      }
    };

    _this.handleFormBlur = function () {
      return _this.setState({ showURLInput: false });
    };

    _this.handleCommentFormBlur = function () {
      return _this.setState({ showCommentInput: false });
    };

    var info_block = _this.props.info_block[_this.props.data_parent];
    var HTMLData = info_block[_this.props.data_id][_this.props.data_type];

    var decorator = new _draftJs.CompositeDecorator([{
      strategy: findLinkEntities,
      component: Link
    }, {
      strategy: findCommentEntities,
      component: CommentBox,
      props: { editor: _this, internalEditorState: _this.state }
    }]);

    // console.log(HTMLData);
    // console.log(((JSON.parse(HTMLData))));
    _this.state = {
      editorState: _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(JSON.parse(HTMLData)), decorator),
      visible: false,
      showURLInput: false,
      urlValue: '',
      commentValue: '',
      showCommentInput: false,
      text_analysis_data: false,
      highlighted_action_verb: false,
      analysis_mode_on: false,
      commentEntityKey: false
    };

    // this.focus = () => {this.refs.editor.focus()}
    _this.focus = function () {
      _this.editor.focus();
      _this.setState({ visible: true });
    };

    _this.onBlur = function (editorState) {
      _this.setState({ visible: false });
      _this.saveState();
    };

    _this.forceRender = function () {
      var editorState = _this.state.editorState;
      var contentState = editorState.getCurrentContent();

      var newEditorStateInstance = _draftJs.EditorState.createWithContent(contentState, decorator);

      var copyOfEditorState = _draftJs.EditorState.set(newEditorStateInstance, {
        selection: editorState.getSelection(),
        undoStack: editorState.getUndoStack(),
        redoStack: editorState.getRedoStack(),
        lastChangeType: editorState.getLastChangeType()
      });
      _this.setState({ editorState: copyOfEditorState });
    };

    _this.onChange = function (editorState) {
      // console.log(1, editorState.getCurrentContent().getPlainText());


      var contentState = editorState.getCurrentContent();
      var startKey = editorState.getSelection().getStartKey();
      var startOffset = editorState.getSelection().getStartOffset();
      var blockWithEntityAtBeginning = contentState.getBlockForKey(startKey);
      var entityKey = blockWithEntityAtBeginning.getEntityAt(startOffset);

      if (entityKey !== null && contentState.getEntity(entityKey).getType() === 'COMMENT') {
        var selectedComment = document.getElementsByClassName('draft-comment-' + entityKey)[0];

        if (!_this.state.commentEntityKey) {
          if (selectedComment !== undefined) {
            selectedComment.style.visibility = 'visible';
            selectedComment.style.opacity = '1';
          }
        } else if (_this.state.commentEntityKey !== entityKey) {
          // console.log(entityKey);
          var allComments = document.getElementsByClassName('draft-comment');
          for (var i = 0; i < allComments.length; i++) {
            allComments[i].style.visibility = 'hidden';
            allComments[i].style.opacity = '0';
          }
          if (selectedComment !== undefined) {
            selectedComment.style.visibility = 'visible';
            selectedComment.style.opacity = '1';
          }
        }
        _this.setState({ commentEntityKey: entityKey });
      } else {
        if (_this.state.commentEntityKey) {
          var _allComments = document.getElementsByClassName('draft-comment');
          for (var i = 0; i < _allComments.length; i++) {
            _allComments[i].style.visibility = 'hidden';
            _allComments[i].style.opacity = '0';
          }
        }
        _this.setState({ commentEntityKey: false });
      }

      _this.setState({ editorState: editorState });
      var element_id = _this.props.data_id;
      var element_parent = _this.props.data_parent;
      var element_type = _this.props.data_type;

      // Worst Hack ever done!!
      // TODO: need to get a json object from server instead of string.
      // or need to process the data coming from server. THIS IS BADD!!!!
      // Doing dummy operation each time to avoid collision with initial array!
      var html = (0, _stringify2.default)((0, _draftJs.convertToRaw)(editorState.getCurrentContent()));
      // console.log(html);
      // if(element_parent === 'professional'){
      //   this.props.updateProfessionalDetails(html, element_id, element_type);
      // } else{
      //   this.props.updateMiscellaneousInfo(html, element_id, element_type);
      // }
      _this.props.updateInfo(html, element_id, element_type, element_parent);
    };

    _this.handleKeyCommand = function (command) {
      return _this._handleKeyCommand(command);
    };
    _this.myKeyBindingFn = function (e) {
      return _this._myKeyBindingFn(e);
    };
    _this.onTab = function (e) {
      return _this._onTab(e);
    };
    _this.toggleBlockType = function (type) {
      return _this._toggleBlockType(type);
    };
    _this.toggleInlineStyle = function (style) {
      return _this._toggleInlineStyle(style);
    };
    _this.toggleColor = function (toggledColor) {
      return _this._toggleColor(toggledColor);
    };

    _this.promptForLink = _this._promptForLink.bind(_this);
    _this.onURLChange = function (e) {
      return _this.setState({ urlValue: e.target.value });
    };
    _this.confirmLink = _this._confirmLink.bind(_this);
    _this.onLinkInputKeyDown = _this._onLinkInputKeyDown.bind(_this);
    _this.removeLink = _this._removeLink.bind(_this);

    _this.promptForComment = _this._promptForComment.bind(_this);
    _this.onCommentChange = function (commentHtml) {
      return _this.setState({ commentValue: commentHtml });
    };
    _this.confirmComment = _this._confirmComment.bind(_this);
    _this.onCommentInputKeyDown = _this._onCommentInputKeyDown.bind(_this);
    _this.onAddImage = _this._onAddImage.bind(_this);

    _this.blockRenderer = function (contentBlock) {
      return _this._blockRenderer(contentBlock);
    };
    _this.handlePastedText = _this.handlePastedText.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(MultiLine, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.copySource = (0, _draftjsConductor.registerCopySource)(this.editor);
    }
  }, {
    key: 'handlePastedText',
    value: function handlePastedText(text, html, editorState) {
      var newState = (0, _draftjsConductor.handleDraftEditorPastedText)(html, editorState);

      if (newState) {
        this.onChange(newState);
        return true;
      }

      return false;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.copySource) {
        this.copySource.unregister();
      }
    }
  }, {
    key: '_blockRenderer',
    value: function _blockRenderer(contentBlock) {
      var data_parent = this.props.data_parent;
      var _state = this.state,
          text_analysis_data = _state.text_analysis_data,
          analysis_mode_on = _state.analysis_mode_on;


      if (contentBlock.getType() === 'atomic') {
        return {
          component: _components.MediaBlock,
          editable: true,
          props: {
            editor: this
          }
        };
      }

      if (analysis_mode_on) {
        if (data_parent == 'PR') {
          if (text_analysis_data && analysis_mode_on) {
            var type = contentBlock.getType();
            var blockKey = contentBlock.getKey();
            var info_block_object = this.props.info_block[this.props.data_parent][this.props.data_id];
            var info_block_id = info_block_object['id'];

            if (type === 'unordered-list-item') {
              if (info_block_id in text_analysis_data) {
                if (blockKey in text_analysis_data[info_block_id]) {

                  var pos_list = text_analysis_data[info_block_id][blockKey]['pos'];
                  var word_list = text_analysis_data[info_block_id][blockKey]['text'];
                  var dependency_list = text_analysis_data[info_block_id][blockKey]['dependency'];
                  var lemma_list = text_analysis_data[info_block_id][blockKey]['lemma'];
                  var tag_list = text_analysis_data[info_block_id][blockKey]['tag'];
                  var shape_list = text_analysis_data[info_block_id][blockKey]['shape'];
                  return {
                    component: _components.TextAnalysis,
                    editable: true,
                    props: {
                      pos_list: pos_list,
                      word_list: word_list,
                      dependency_list: dependency_list,
                      lemma_list: lemma_list,
                      tag_list: tag_list,
                      shape_list: shape_list,
                      date_from: info_block_object['date_from'],
                      date_to: info_block_object['date_to']
                    }
                  };
                }
              }
            }
          }
        }
      }
    }
  }, {
    key: '_myKeyBindingFn',
    value: function _myKeyBindingFn(e) {
      if (e.keyCode === 67 /* `S` key */ && hasCommandModifier(e)) {
        //checking if content template is not free or user is not subscribed or if everything is free
        if (!(this.props.content_template_free || this.props.subscribed || this.props.all_templates_free)) {
          return 'copy-tried';
        }
        return (0, _draftJs.getDefaultKeyBinding)(e);
      }

      if (e.keyCode === 75 /* `S` key */ && hasCommandModifier(e)) {
        this.promptForComment(e);
        return 'comment-modal-opened';
      }

      return (0, _draftJs.getDefaultKeyBinding)(e);
    }
  }, {
    key: '_handleKeyCommand',
    value: function _handleKeyCommand(command) {
      //checking if the copied is fired
      var editorState = this.state.editorState;


      if (command === 'split-block') {
        var selection = editorState.getSelection();
        var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
        if (blockType === 'header-three') {
          var elements = document.getElementsByClassName('primary-background');
          for (var i = 0; i < elements.length; i++) {
            elements[i].style.backgroundColor = this.props.primary_color;
          }
        }
        this.forceRender();
      }
      if (command === 'copy-tried') {
        if (!(this.props.content_template_free || this.props.subscribed || this.props.all_templates_free)) {
          return false;
        }
      }
      var newState = _draftJs.RichUtils.handleKeyCommand(editorState, command);
      if (newState) {
        this.onChange(newState);
        return true;
      }
      return false;
    }
  }, {
    key: '_onTab',
    value: function _onTab(e) {
      var maxDepth = 4;
      this.onChange(_draftJs.RichUtils.onTab(e, this.state.editorState, maxDepth));
    }
  }, {
    key: '_toggleBlockType',
    value: function _toggleBlockType(blockType) {
      this.onChange(_draftJs.RichUtils.toggleBlockType(this.state.editorState, blockType));
      this.props.ReactGA.event({
        category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
        action: 'Font - ' + blockType,
        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
      });
    }
  }, {
    key: '_toggleInlineStyle',
    value: function _toggleInlineStyle(inlineStyle) {
      this.onChange(_draftJs.RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle));
      this.props.ReactGA.event({
        category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
        action: 'Font - ' + inlineStyle,
        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
      });
    }
  }, {
    key: '_toggleColor',
    value: function _toggleColor(toggledColor) {
      var editorState = this.state.editorState;

      var selection = editorState.getSelection();
      // Let's just allow one color at a time. Turn off all active colors.
      var nextContentState = (0, _keys2.default)(colorStyleMap).reduce(function (contentState, color) {
        return _draftJs.Modifier.removeInlineStyle(contentState, selection, color);
      }, editorState.getCurrentContent());
      var nextEditorState = _draftJs.EditorState.push(editorState, nextContentState, 'change-inline-style');
      var currentStyle = editorState.getCurrentInlineStyle();
      // Unset style override for current color.
      if (selection.isCollapsed()) {
        nextEditorState = currentStyle.reduce(function (state, color) {
          return _draftJs.RichUtils.toggleInlineStyle(state, color);
        }, nextEditorState);
      }
      // If the color is being toggled on, apply it.
      if (!currentStyle.has(toggledColor)) {
        nextEditorState = _draftJs.RichUtils.toggleInlineStyle(nextEditorState, toggledColor);
      }
      this.onChange(nextEditorState);
      this.props.ReactGA.event({
        category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
        action: 'Font - ' + toggledColor,
        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
      });
    }
  }, {
    key: '_promptForLink',
    value: function _promptForLink(e) {
      var _this2 = this;

      e.preventDefault();
      var editorState = this.state.editorState;

      var selection = editorState.getSelection();
      if (!selection.isCollapsed()) {
        var contentState = editorState.getCurrentContent();
        var startKey = editorState.getSelection().getStartKey();
        var startOffset = editorState.getSelection().getStartOffset();
        var blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
        var linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);

        var url = '';
        if (linkKey) {
          var linkInstance = contentState.getEntity(linkKey);
          url = linkInstance.getData().url;
        }

        this.setState({
          showURLInput: true,
          urlValue: url
        }, function () {
          setTimeout(function () {
            return _this2.refs.url.focus();
          }, 0);
        });
      }
    }
  }, {
    key: '_confirmLink',
    value: function _confirmLink(e) {
      var _this3 = this;

      e.preventDefault();
      var _state2 = this.state,
          editorState = _state2.editorState,
          urlValue = _state2.urlValue;

      var contentState = editorState.getCurrentContent();
      var contentStateWithEntity = contentState.createEntity('LINK', 'MUTABLE', { url: urlValue });
      var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
      var newEditorState = _draftJs.EditorState.set(editorState, { currentContent: contentStateWithEntity });
      this.setState({
        editorState: _draftJs.RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), entityKey),
        showURLInput: false,
        urlValue: ''
      }, function () {
        setTimeout(function () {
          return _this3.editor.focus();
        }, 0);
      });
    }
  }, {
    key: '_onLinkInputKeyDown',
    value: function _onLinkInputKeyDown(e) {
      if (e.which === 13) {
        this._confirmLink(e);
      }
    }
  }, {
    key: '_removeLink',
    value: function _removeLink(e) {
      e.preventDefault();
      var editorState = this.state.editorState;

      var selection = editorState.getSelection();
      if (!selection.isCollapsed()) {
        this.setState({
          editorState: _draftJs.RichUtils.toggleLink(editorState, selection, null)
        });
      }
    }
  }, {
    key: '_promptForComment',
    value: function _promptForComment(e) {
      e.preventDefault();
      var editorState = this.state.editorState;

      var selection = editorState.getSelection();
      if (!selection.isCollapsed()) {
        var contentState = editorState.getCurrentContent();
        var startKey = editorState.getSelection().getStartKey();
        var startOffset = editorState.getSelection().getStartOffset();
        var blockWithCommentAtBeginning = contentState.getBlockForKey(startKey);
        var commentKey = blockWithCommentAtBeginning.getEntityAt(startOffset);

        var comment = '';
        if (commentKey) {
          var commentInstance = contentState.getEntity(commentKey);
          comment = commentInstance.getData().comment;
        }

        this.setState({
          showCommentInput: true,
          commentValue: comment
        }, function () {});
      }
    }
  }, {
    key: '_confirmComment',
    value: function _confirmComment(e) {
      var _this4 = this;

      e.preventDefault();
      var _state3 = this.state,
          editorState = _state3.editorState,
          commentValue = _state3.commentValue;

      var contentState = editorState.getCurrentContent();
      var contentStateWithEntity = contentState.createEntity('COMMENT', 'MUTABLE', { comment: commentValue });
      var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
      var contentStateWithComment = _draftJs.Modifier.applyEntity(contentStateWithEntity, editorState.getSelection(), entityKey);

      var editorStateWithComment = _draftJs.EditorState.push(editorState, contentStateWithComment, 'add-comment');

      this.setState({
        editorState: editorStateWithComment,
        showCommentInput: false,
        commentValue: ''
      }, function () {
        setTimeout(function () {
          return _this4.editor.focus();
        }, 0);
      });
    }
  }, {
    key: '_onCommentInputKeyDown',
    value: function _onCommentInputKeyDown(e) {
      if (e.which === 13) {
        this._confirmComment(e);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this5 = this;

      if (this.props.analysis_mode_on && !nextProps.analysis_mode_on) {
        this.setState({ analysis_mode_on: nextProps.analysis_mode_on, text_analysis_data: false });

        var decorator = new _draftJs.CompositeDecorator([{
          strategy: findLinkEntities,
          component: Link
        }, {
          strategy: findCommentEntities,
          component: CommentBox,
          props: { editor: this }
        }]);

        this.setState({
          editorState: _draftJs.EditorState.set(this.state.editorState, { decorator: decorator })
        });

        // this.forceRender();
      } else if (!this.props.analysis_mode_on && nextProps.analysis_mode_on) {
        this.setState({ analysis_mode_on: nextProps.analysis_mode_on });
      }

      if (nextProps.analysis_mode_on) {
        if (this.props.data_parent == 'PR') {

          if (!nextProps.highlighted_action_verb) {

            var _decorator = new _draftJs.CompositeDecorator([{
              strategy: findLinkEntities,
              component: Link
            }, {
              strategy: findCommentEntities,
              component: CommentBox,
              props: { editor: this }
            }]);

            this.setState({
              highlighted_action_verb: nextProps.highlighted_action_verb,
              editorState: _draftJs.EditorState.set(this.state.editorState, { decorator: _decorator })
            });
          } else {

            var generateDecorator = function generateDecorator(highlightTerm, text_analysis_data, info_block_id) {

              return new _draftJs.CompositeDecorator([{
                strategy: function strategy(contentBlock, callback) {
                  if (highlightTerm !== '') {
                    findWithRegex(highlightTerm, text_analysis_data, info_block_id, contentBlock, callback);
                  }
                },
                component: _components.ActionVerbBox,
                props: { editor: _this5 }
              }, {
                strategy: function strategy(contentBlock, callback) {
                  findSpaces(text_analysis_data, info_block_id, contentBlock, callback);
                },
                component: ExtraSpacesBlock,
                props: { editor: _this5 }
              }, {
                strategy: findLinkEntities,
                component: Link
              }, {
                strategy: findCommentEntities,
                component: CommentBox,
                props: { editor: _this5 }
              }]);
            };

            var info_block_id = this.props.info_block[this.props.data_parent][this.props.data_id]['id'];

            this.setState({
              highlighted_action_verb: nextProps.highlighted_action_verb,
              editorState: _draftJs.EditorState.set(this.state.editorState, {
                decorator: generateDecorator(nextProps.highlighted_action_verb, nextProps.text_analysis_data, info_block_id)
              })
            });
          }

          if (nextProps.text_analysis_data != this.props.text_analysis_data) {
            this.setState({ text_analysis_data: nextProps.text_analysis_data });
            this.forceRender();
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var urlInput = void 0;
      if (this.state.showURLInput) {
        var _React$createElement;

        urlInput = _react2.default.createElement(
          _semanticUiReact.Modal,
          { centered: true, closeIcon: true, size: 'tiny', open: this.state.showURLInput, onClose: this.handleFormBlur },
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            'Enter  URL:'
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(_semanticUiReact.Input, (_React$createElement = {
              fluid: true,
              placeholder: 'Please Include http:// or https:// in the url',
              style: { width: '100%' },
              onChange: this.onURLChange,
              ref: 'url'
            }, (0, _defineProperty3.default)(_React$createElement, 'style', linkStyles.urlInput), (0, _defineProperty3.default)(_React$createElement, 'type', 'text'), (0, _defineProperty3.default)(_React$createElement, 'value', this.state.urlValue), (0, _defineProperty3.default)(_React$createElement, 'onKeyDown', this.state.urlValue === '' ? null : this.onLinkInputKeyDown), _React$createElement))
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { positive: true, icon: 'checkmark', labelPosition: 'right', content: 'Confirm', onMouseDown: this.state.urlValue === '' ? null : this.confirmLink })
          )
        );
      }

      var commentInput = void 0;
      if (this.state.showCommentInput) {
        var _React$createElement2;

        var selectionState = this.state.editorState.getSelection();
        var anchorKey = selectionState.getAnchorKey();
        var currentContent = this.state.editorState.getCurrentContent();
        var currentContentBlock = currentContent.getBlockForKey(anchorKey);
        var start = selectionState.getStartOffset();
        var end = selectionState.getEndOffset();
        var selectedText = currentContentBlock.getText().slice(start, end);
        var allComments = document.getElementsByClassName('draft-comment');

        commentInput = _react2.default.createElement(
          _semanticUiReact.Modal,
          { centered: true, closeIcon: true, size: 'tiny', open: this.state.showCommentInput, onClose: this.handleCommentFormBlur },
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            'Write Your Comment:'
          ),
          _react2.default.createElement(
            'p',
            { style: { padding: '10px', textAlign: 'center' } },
            allComments.length
          ),
          _react2.default.createElement(
            'p',
            { style: { padding: '10px', textAlign: 'center' } },
            selectedText
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            { style: { paddingTop: '0px', paddingBottom: '0px' } },
            _react2.default.createElement(_components.CommentEditor, (_React$createElement2 = {
              fluid: true,
              placeholder: 'Enter the text for your comment',
              style: { width: '100%' },
              onCommentChange: this.onCommentChange
            }, (0, _defineProperty3.default)(_React$createElement2, 'style', linkStyles.commentInput), (0, _defineProperty3.default)(_React$createElement2, 'value', this.state.commentValue), (0, _defineProperty3.default)(_React$createElement2, 'confirmComment', this.confirmComment), _React$createElement2))
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { positive: true, icon: 'checkmark', labelPosition: 'right', content: 'Confirm', onMouseDown: this.state.commentValue === '' ? null : this.confirmComment })
          )
        );
      }

      var _state4 = this.state,
          editorState = _state4.editorState,
          text_analysis_data = _state4.text_analysis_data;
      var readOnly = this.props.readOnly;


      var sectionLineSpacing = 1.3 + this.props.sectionMargin / 10;
      // If the user changes block type before entering any text, we can
      // either style the placeholder or hide it. Let's just hide it now.
      var className = 'Editor-editor';
      var styles = require('./MultiLine.scss');
      var classMultiRoot = "editor-root " + styles.multiline;
      var visible = this.state.visible;
      // var contentState = editorState.getCurrentContent();


      return _react2.default.createElement(
        'div',
        { onClick: this.focus },
        this.state.visible ? _react2.default.createElement(
          _semanticUiReact.Menu,
          {
            style: { marginTop: 74 },
            size: 'mini',
            fixed: 'top',
            inverted: true,
            className: 'multiLineStyleBar'
          },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', margin: '0 auto' } },
            _react2.default.createElement(InlineStyleControls, {
              editorState: this.state.editorState,
              onToggle: this.toggleInlineStyle
            }),
            _react2.default.createElement(BlockStyleControls, {
              editorState: editorState,
              onToggle: this.toggleBlockType
            }),
            _react2.default.createElement(ColorControls, {
              editorState: editorState,
              onToggle: this.toggleColor
            }),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex' }, className: 'RichEditor-controls' },
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { className: 'editor-styleButton', onMouseDown: this.promptForLink },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkify' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { className: 'editor-styleButton', onMouseDown: this.removeLink },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlinkify' })
              ),
              this.props.show_comment_button && _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { className: 'editor-styleButton', onMouseDown: this.promptForComment },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment' })
              ),
              this.props.show_image_upload && _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { className: 'editor-styleButton', onMouseDown: this.onAddImage },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'image' })
              )
            )
          )
        ) : _react2.default.createElement('div', null),
        urlInput,
        this.props.show_comment_button && commentInput,
        _react2.default.createElement(
          'div',
          { className: classMultiRoot, style: { lineHeight: '' + sectionLineSpacing } },
          _react2.default.createElement(
            'div',
            { className: className, style: this.props.editorRootStyle },
            _react2.default.createElement(_draftJs.Editor, {
              blockStyleFn: getBlockStyle,
              blockRendererFn: this.blockRenderer,
              customStyleMap: colorStyleMap,
              editorState: editorState,
              handleKeyCommand: this.handleKeyCommand,
              onChange: this.onChange,
              keyBindingFn: this.myKeyBindingFn,
              onTab: this.onTab,
              placeholder: 'Enter text here..',
              spellCheck: true,
              ref: function ref(element) {
                _this6.editor = element;
              },
              onBlur: this.onBlur,
              blockRenderMap: extendedBlockRenderMap,
              handlePastedText: this.handlePastedText
            }),
            _react2.default.createElement('div', { className: 'toolbar-draft' })
          )
        )
      );
    }
  }]);
  return MultiLine;
}(_react.Component)) || _class);
exports.default = MultiLine;

var KeySkillsBlock = function (_Component2) {
  (0, _inherits3.default)(KeySkillsBlock, _Component2);

  function KeySkillsBlock(props) {
    (0, _classCallCheck3.default)(this, KeySkillsBlock);
    return (0, _possibleConstructorReturn3.default)(this, (KeySkillsBlock.__proto__ || (0, _getPrototypeOf2.default)(KeySkillsBlock)).call(this, props));
  }

  (0, _createClass3.default)(KeySkillsBlock, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'KeySkillsBlock' },
        this.props.children
      );
    }
  }]);
  return KeySkillsBlock;
}(_react.Component);

var blockRenderMap = _immutable2.default.Map({
  'header-three': {
    // element is used during paste or html conversion to auto match your component;
    // it is also retained as part of this.props.children and not stripped out
    element: 'h3',
    wrapper: _react2.default.createElement(KeySkillsBlock, null)
  }
});

// keep support for other draft default block types and add our myCustomBlock type
var extendedBlockRenderMap = _draftJs.DefaultDraftBlockRenderMap.merge(blockRenderMap);

MultiLine.defaultProps = {
  editorRootStyle: { minHeight: '0px' }
};

function getBlockStyle(block) {
  switch (block.getType()) {
    case 'blockquote':
      return 'RichEditor-blockquote';
    case 'header-three':
      return 'primary-background';
    default:
      return null;
  }
}

var StyleButton = function (_React$Component) {
  (0, _inherits3.default)(StyleButton, _React$Component);

  function StyleButton() {
    (0, _classCallCheck3.default)(this, StyleButton);

    var _this8 = (0, _possibleConstructorReturn3.default)(this, (StyleButton.__proto__ || (0, _getPrototypeOf2.default)(StyleButton)).call(this));

    _this8.onToggle = function (event) {
      event.preventDefault();
      _this8.props.onToggle(_this8.props.style);
    };
    return _this8;
  }

  (0, _createClass3.default)(StyleButton, [{
    key: 'render',
    value: function render() {
      var className = 'editor-styleButton';
      if (this.props.active) {
        className += ' editor-activeButton';
      }

      if (this.props.name === 'header') {
        return _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { className: className,
            onMouseDown: this.onToggle,
            name: this.props.name },
          this.props.label
        );
      }
      if (this.props.name === 'font') {
        return _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { style: { color: this.props.label }, className: className,
            onMouseDown: this.onToggle,
            name: this.props.name },
          _react2.default.createElement(_semanticUiReact.Icon, { name: this.props.name })
        );
      } else {
        return _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { className: className,
            onMouseDown: this.onToggle,
            name: this.props.name },
          _react2.default.createElement(_semanticUiReact.Icon, { name: this.props.name })
        );
      }
    }
  }]);
  return StyleButton;
}(_react2.default.Component);

var INLINE_STYLES = [{ label: 'Bold', style: 'BOLD', name: 'bold' }, { label: 'Italic', style: 'ITALIC', name: 'italic' }, { label: 'Underline', style: 'UNDERLINE', name: 'underline' }];

var InlineStyleControls = function InlineStyleControls(props) {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex' }, className: 'editor-controls' },
    INLINE_STYLES.map(function (type) {
      return _react2.default.createElement(StyleButton, {
        key: type.label,
        active: currentStyle.has(type.style),
        label: type.label,
        onToggle: props.onToggle,
        style: type.style,
        name: type.name
      });
    })
  );
};

var BLOCK_TYPES = [{ label: 'H1', style: 'header-one', name: 'header' }, { label: 'H2', style: 'header-two', name: 'header' }, { label: 'H3', style: 'header-three', name: 'header' },
//{label: 'Blockquote', style: 'blockquote', name:'header'},
{ label: 'UL', style: 'unordered-list-item', name: 'unordered list' }, { label: 'OL', style: 'ordered-list-item', name: 'ordered list' }];
var BlockStyleControls = function BlockStyleControls(props) {
  var editorState = props.editorState;

  var selection = editorState.getSelection();
  var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex' }, className: 'RichEditor-controls' },
    BLOCK_TYPES.map(function (type) {
      return _react2.default.createElement(StyleButton, {
        key: type.label,
        active: type.style === blockType,
        label: type.label,
        onToggle: props.onToggle,
        style: type.style,
        name: type.name
      });
    })
  );
};

var colorStyleMap = {
  red: {
    color: 'rgba(69, 15, 18, 1.0)'
  },
  orange: {
    color: 'rgba(255, 127, 0, 1.0)'
  },
  yellow: {
    color: 'rgba(180, 180, 0, 1.0)'
  },
  green: {
    color: 'rgba(0, 180, 0, 1.0)'
  },
  blue: {
    color: 'rgba(0, 112, 192, 1.0)'
  },
  indigo: {
    color: 'rgba(75, 0, 130, 1.0)'
  },
  violet: {
    color: 'violet'
  },
  centeralign: {
    textAlign: 'center',
    display: 'block'
  },
  leftalign: {
    textAlign: 'left',
    display: 'block'
  },
  rightalign: {
    textAlign: 'right',
    display: 'block'
  },
  justify: {
    textAlign: 'justify',
    display: 'block'
  }
};

var COLORS = [
// {label: 'primary_color', style: 'primary_color', name: 'font'},
//{label: 'Orange', style: 'orange', name: 'font'},
{ label: 'Red', style: 'red', name: 'font' }, { label: 'Blue', style: 'blue', name: 'font' },
//{label: 'Yellow', style: 'yellow', name: 'font'},
//{label: 'Green', style: 'green', name: 'font'},
// {label: 'secondary_color', style: 'secondary_color', name: 'font'},
// {label: 'Indigo', style: 'indigo', name: 'font'},
//{label: 'Violet', style: 'violet', name: 'font'},
{ label: 'Center', style: 'centeralign', name: 'align center' }, { label: 'Left', style: 'leftalign', name: 'align left' }, { label: 'Right', style: 'rightalign', name: 'align right' }, { label: 'Justify', style: 'justify', name: 'align justify' }];
var ColorControls = function ColorControls(props) {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex' } },
    COLORS.map(function (type) {
      return _react2.default.createElement(StyleButton, {
        key: type.label,
        active: currentStyle.has(type.style),
        label: type.label,
        onToggle: props.onToggle,
        style: type.style,
        name: type.name
      });
    })
  );
};

function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
  }, callback);
}
var Link = function Link(props) {
  var _props$contentState$g = props.contentState.getEntity(props.entityKey).getData(),
      url = _props$contentState$g.url;

  return _react2.default.createElement(
    'a',
    { rel: 'nofollow noreferrer', target: '_blank', href: url, style: linkStyles.link },
    props.children
  );
};

var linkStyles = {
  root: {
    fontFamily: '\'Georgia\', serif',
    padding: 20,
    width: 600
  },
  buttons: {
    marginBottom: 10
  },
  urlInputContainer: {
    marginBottom: 10
  },
  urlInput: {
    fontFamily: '\'Georgia\', serif',
    marginRight: 10,
    padding: 3
  },
  editor: {
    border: '1px solid #ccc',
    cursor: 'text',
    minHeight: 80,
    padding: 10
  },
  button: {
    marginTop: 10,
    textAlign: 'center'
  },
  link: {
    color: '#3b5998',
    textDecoration: 'underline'
  },
  comment: {
    background: 'lightyellow',
    display: 'inline-block'
  },
  commentInput: {
    width: '100%',
    resize: 'none',
    border: '1px solid grey !important'
  }
};

var ExtraSpacesBlock = function ExtraSpacesBlock(props) {
  return _react2.default.createElement(
    'span',
    { style: { backgroundColor: 'lightblue' } },
    props.children
  );
};

function findSpaces(text_analysis_data, info_block_id, contentBlock, callback) {
  if (info_block_id in text_analysis_data) {
    var blockKey = contentBlock.getKey();
    if (blockKey in text_analysis_data[info_block_id]) {
      var regex = /(\s\s+|\s,|,\S)/g;
      var text = contentBlock.getText().toLowerCase();
      var matchArr = void 0,
          start = void 0,
          end = void 0;
      while ((matchArr = regex.exec(text)) !== null) {
        start = matchArr.index;
        end = start + matchArr[0].length;
        callback(start, end);
      }
    }
  }
};

function findWithRegex(highlightTerm, text_analysis_data, info_block_id, contentBlock, callback) {
  if (info_block_id in text_analysis_data) {

    var blockKey = contentBlock.getKey();
    if (blockKey in text_analysis_data[info_block_id]) {
      var data = text_analysis_data[info_block_id][blockKey];
      if (data['lemma'].indexOf(highlightTerm) >= 0) {
        var index_of_word = data['lemma'].indexOf(highlightTerm);
        var wordToMatch = data['text'][index_of_word];
        var regex = new RegExp(wordToMatch, 'g');
        var text = contentBlock.getText().toLowerCase();
        var matchArr = void 0,
            start = void 0,
            end = void 0;
        while ((matchArr = regex.exec(text)) !== null) {
          start = matchArr.index;
          end = start + matchArr[0].length;
          callback(start, end);
        }
      }
    }
  }
};

function findCommentEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'COMMENT';
  }, callback);
}

var CommentBox = function CommentBox(props) {
  var _props$contentState$g2 = props.contentState.getEntity(props.entityKey).getData(),
      comment = _props$contentState$g2.comment;

  var draftCommentState = _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(JSON.parse(comment)));
  var editor = props.editor,
      decoratedText = props.decoratedText,
      internalEditorState = props.internalEditorState;

  var selection = props.children['0'].props;
  var commentVisible = void 0;
  // const blockMap = props.contentState.getBlockMap().toArray();
  // const blockKey = props.block.key;
  // const lineNumber = blockMap.findIndex(block => blockKey === block.key) + 1;

  return _react2.default.createElement(
    'span',
    { className: 'draftCommentWrapper', style: { position: 'relative' } },
    _react2.default.createElement(
      'span',
      { className: 'draft-comment draft-comment-' + props.entityKey },
      _react2.default.createElement(
        'div',
        { contentEditable: false, style: { display: 'flex', justifyContent: 'space-between', paddingBottom: '5px' } },
        _react2.default.createElement(
          'div',
          { style: { fontWeight: 'bold' } },
          'Comment:'
        ),
        _react2.default.createElement(_semanticUiReact.Icon, { style: { cursor: 'pointer' }, name: 'trash', onClick: function onClick(event) {
            event.stopPropagation();
            var selectionState = _draftJs.SelectionState.createEmpty(selection.block.key).merge({
              anchorOffset: selection.start,
              focusOffset: selection.start + decoratedText.length
            });

            var editorState = editor.state.editorState;

            var newState = _draftJs.Modifier.replaceText(editorState.getCurrentContent(), selectionState, decoratedText, null, null);
            var newEditorState = _draftJs.EditorState.push(editorState, newState, 'delete-comment');
            editor.updateEditorInfo(newEditorState);
          }
        })
      ),
      _react2.default.createElement(_draftJs.Editor, {
        style: { textAlign: 'left', fontSize: '10px' },
        editorState: draftCommentState,
        readOnly: true
      })
    ),
    _react2.default.createElement(
      'span',
      { className: 'coloredComment', style: { display: 'inline' } },
      props.children
    )
  );
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MultiLine/MultiLine.js
// module id = 1740
// module chunks = 0